const jobcolors = {
  requested: { back: "#ffbb5c", font: "black" },
  booked: { back: "#b9e6ac", font: "black" },
  intransit: { back: "#3664c7", font: "white" },
  completed: { back: "#1a7500", font: "white" },
  cancelled: { back: "#7a1017", font: "white" },
};

export default jobcolors;
